import { AdPlacementProps } from '@components/common/AdPlacement/AdPlacement.types';
import { useScriptWithBody } from '@hooks/useScriptWithBody';
import { FC, useEffect, useMemo } from 'react';

export const AdPlacement: FC<AdPlacementProps> = ({ placement, id, adPlacements }) => {
  const ads = useMemo(
    () => adPlacements.filter((adPlacement) => adPlacement.placement === placement),
    [adPlacements, placement],
  );

  const { executeScript, removeScript } = useScriptWithBody();

  useEffect(() => {
    if (ads && ads.length > 0 && ads[0].script) {
      const { script, id: internalId } = ads[0];

      executeScript(script, id ?? internalId);
    }

    return () => removeScript();
  }, [ads, id, executeScript, removeScript]);

  if (ads && ads.length > 0) {
    const { html } = ads[0];

    return <div dangerouslySetInnerHTML={{ __html: html }} />;
  }

  return null;
};
